export const book = () => (
  <path
    d="M4 19.5A2.5 2.5 0 016.5 17H20M4 19.5A2.5 2.5 0 006.5 22H18v-5h2M4 19.5v-15A2.5 2.5 0 016.5 2H20v15"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
